<mat-form-field *ngIf="model.additional?.paperProcessOverride" data-test="gsm-geschaedigtes-fahrzeug_beilage-field">
  <mat-label>Kollisionspunkte erfassen?</mat-label>
  <mat-select
    [(ngModel)]="isSieheBeilage"
    [ngModelOptions]="{ standalone: true }"
    [disabled]="model.disabled"
    (ngModelChange)="onSieheBeilageChange()"
    data-test="gsm-geschaedigtes-fahrzeug_beilage-select"
  >
    <mat-option [value]="true">
      <span>Siehe Beilage</span>
    </mat-option>
    <mat-option [value]="false">
      <span>Kollisionspunkte erfassen</span>
    </mat-option>
  </mat-select>
</mat-form-field>
<dynamic-material-form
  #form
  [hidden]="isSieheBeilage"
  [model]="formModel"
  [group]="formGroup"
  (change)="onFormChange()"
  data-test="gsm-geschaedigtes-fahrzeug_form"
>
</dynamic-material-form>
